import {DeclarativeMutationConfig, Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {CreateProjectBillToInput, CreateProjectBillToMutation} from './__generated__/CreateProjectBillToMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../ts/MutationTypes';

const mutation = graphql`
	mutation CreateProjectBillToMutation($input: CreateProjectBillToInput!) {
		createProjectBillTo(input: $input) {
			projectBillTo {
				node {
					id
					clientId
					clientBillToId
					billTo {
						id
						name
					}
					projectId
					billFrom {
						id
						name
						integration
					}
				}
			}
		}
	}
`;

function getConfigs(input): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.projectId,
			connectionInfo: [
				{
					key: 'Project_projectBillTos',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'projectBillTo',
		},
	];
}

function commit(
	environment: Environment,
	input: MutationInput<CreateProjectBillToInput>,
	onSuccess?: RelayOnCompleted<CreateProjectBillToMutation>,
	onError?: RelayOnError
): Disposable {
	trackEvent('Project Bill To', 'Created', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
